import React from 'react'

import { InsertionFlowScreensProps } from '../../../../../@types/props-types'
import { SCREEN_API_SEARCH_DATA, SCREENS } from '../../../../../services/domain/wizardScreens'
import { ApiSearchDataScreenValidationResult } from '../../../../../@types/validation-types'
import ScreenContainer from '../../../../common/containers/screenContainer/ScreenContainer'
import { FieldProps } from '../../../../../@types/types'
import { ScreenLayout } from '../../../../common/containers/screenLayout/ScreenLayout'
import { ApiSearchField } from './fields/ApiSearchField'
import { ApiSearchFieldToggler } from './fields/ApiSearchFieldToggler'

const screen = SCREENS[SCREEN_API_SEARCH_DATA]
export type ApiSearchDataAdditionalProps = {
  headerKey?: string
}

const ApiSearchData: React.FC<
  InsertionFlowScreensProps<ApiSearchDataScreenValidationResult> & ApiSearchDataAdditionalProps
> = ({
  flowInformation,
  insertionData,
  validationMessages,
  onChange,
  onNavigate,
  headerKey = 'wizard.screen.apiSearchData.header',
}) => {
  const wrapperProps: FieldProps<ApiSearchDataScreenValidationResult> = {
    flowInformation: flowInformation,
    validationMessages: validationMessages,
    insertionData: insertionData,
    screenName: screen.name,
    screenId: screen.id,
    onChange: onChange,
  }

  return (
    <ScreenContainer containerId={screen.id} onNavigate={onNavigate} screen={screen}>
      <ScreenLayout
        id={`${screen.id}-desk-tooltip`}
        headline={headerKey}
        className='grid grid-flex gutter-vertical-l'
        screenName={screen.name}
      >
        <ApiSearchFieldToggler
          initiallyVisible={Boolean(
            insertionData.searchField1 || insertionData.searchField2 || insertionData.searchField3
          )}
        >
          <ApiSearchField {...wrapperProps} propertyName='searchField1' />
          <ApiSearchField {...wrapperProps} propertyName='searchField2' />
          <ApiSearchField {...wrapperProps} propertyName='searchField3' />
        </ApiSearchFieldToggler>
      </ScreenLayout>
    </ScreenContainer>
  )
}

export default ApiSearchData
